export default function getSubscriptionId() {
  if (typeof DISABLE_SUBSCRIPTION_CALLS !== 'undefined') return;
  return typeof Firmhouse !== 'undefined'
    ? Firmhouse?.currentSubscription?.id
    : import.meta.env.VITE_SUBSCRIPTION_ID;
}
